import { Flex, Form } from 'antd';
import React from 'react';

import FieldColor from '../../components/fieldColor';
import WrapperTwoColumn from '../../components/WrapperTwoColumn';
import useAccessForItem from '../../hooks/useAccessForItem';
import useStatusEditProject from '../../hooks/useStatusEditProject';
import FieldEndDate from '../formField/fieldEndDate';
import FieldStartDate from '../formField/fieldStartDate';
import { ProjectAttachments } from '../formField/projectAttachments';
import { ProjectOrPhaseResource } from '../formField/projectOrPhaseResource';
import useControlOtherFields from '../formField/useControlOtherFields';
import { GantItemFormProps } from './gantItemFormProps';

export const GantProjectForm: React.FC<GantItemFormProps> = ({
    currentItem,
    form,
    values,
    bufferItems,
    saveBufferToStore,
}) => {
    useControlOtherFields(form, values, bufferItems, saveBufferToStore, currentItem!, ['name', 'color']);

    const isEditableProject = useStatusEditProject(currentItem?.projectId);
    const access = useAccessForItem(currentItem || null, [
        'work-item.all.create',
        'work-item.all.edit',
        'work-item.all.manage',
        'work-item.owner.create',
        'work-item.owner.edit',
        'work-item.owner.manage',
        'work-item.assignee.create',
        'work-item.assignee.edit',
        'work-item.assignee.manage',
    ]);

    return (
        <Form name="scheduleProjectFrom" layout="vertical" form={form} autoComplete="off">
            <WrapperTwoColumn
                childFirstColumn={
                    <>
                        <FieldStartDate required disabled={!isEditableProject || !access} />
                    </>
                }
                childSecondColumn={
                    <>
                        <FieldEndDate required disabled={!isEditableProject || !access} />
                        <Flex justify={'space-between'} gap={20}>
                            <FieldColor disabled={!isEditableProject || !access} />
                        </Flex>
                    </>
                }
                style={{}}
            />
            {currentItem && <ProjectOrPhaseResource item={currentItem} style={{ marginTop: 32 }} />}

            {currentItem && <ProjectAttachments item={currentItem} style={{ marginTop: 32, marginBottom: 32 }} />}
        </Form>
    );
};
